import React, {useEffect, useRef, useState} from 'react';
import "./french.css";
import {Link, useHistory} from 'react-router-dom'
import Logo from '../assets/img/cd-nav-logo.svg'
import {Button, Form, Input, Modal, Radio, Select, Space} from 'antd';
import Foundation from "../assets/img/foundation.svg";
import Learning from "../assets/img/simple_learning.svg";
import Comprehensive from "../assets/img/comprehensive.svg";
import Recall from "../assets/img/easy_recall.svg";
import Affordable from "../assets/img/affordable.svg";
import TestimonialsSection from "./common/Testimonials";
import {captureLeads_URL} from "../config";


export default function LearnFrench(props) {

    const history = useHistory();
    const formRef = useRef(null)
    const [cls, setCls] = useState('')
    const [stage, setStage] = useState('')
    const [loading, setLoading] = useState(false)
    useEffect(() => {
        document.title = props.title;
    }, [])

    const onFinish = () => {
        setLoading(true)
        formRef.current.validateFields()
            .then(data => {
                fetch(captureLeads_URL, {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        'emails': ['kessar.kc@careerdose.com', 'french@careerdose.com'],
                        'subject': 'Website Landing Page - French lead notification',
                        'body': {...data, "description": "your interest - " + data.description,"product_french_c":"1"},
                        'type': 'french_web'
                    })
                }).then((resp) => {

                })
                history.push({
                    pathname: '/inquiry-received',
                    state: {
                        type: 'french'
                    },
                });
            }).catch(() => {
            setLoading(false)
        })
    };

    const onFinishFailed = errorInfo => {
        console.log('Failed:', errorInfo);
    };
    const {Option} = Select;
    const prefixSelector = (<Form.Item name="prefix" noStyle>
        <Select defaultValue="91" style={{width: 70}} className="border-0">
            <Option value="91" className="font-weight-bold">+91</Option>
        </Select>
    </Form.Item>);


    return (
        <>
            <section className="banner-french">
                <div className="d-flex flex-row pt-4 pl-4 w-100 justify-content-start align-items-center">
                    <Link to="/">
                        <img loading="lazy" src={Logo} alt="Career Dose French Learning"
                             height={window.innerWidth <= 768 ? "45" : "65"}/>
                    </Link>
                </div>
                <div className="container">
                    <div className="py-4">
                        <div className="overlay-white-1 rounded mt-4" id={'featuresAndForm'}>
                            <div className="cell-1 ">
                                <div className="text-center">
                                    <p className="h1 font-weight-bold">
                                        Learn&nbsp;<span className="cd-red-text">French</span> <span
                                        className="h2 font-weight-bold">&#8377;499/month</span><span
                                        className="font-weight-normal" style={{'fontSize': 14}}> (excl. GST)</span>
                                    </p>
                                    <p className="h3 font-weight-bold">90% OFF <del>&#8377;4,999</del></p>
                                </div>
                            </div>
                            <div className='cell-2 '>
                                <div>
                                    <h2 className="font-weight-bold mb-4 text-center text-sm-start"
                                        style={{'font-size': '1.5rem'}}>Key Features</h2>
                                </div>
                                <ul className="d-flex flex-column gap-2 text-sm-start">
                                    <li className="font-weight-bold mb-1" style={{'font-size': '1rem'}}>
                                        Includes comprehension, Grammar, Vocabulary, Dialogues, Exercises and
                                        more.
                                    </li>
                                    <li className="font-weight-bold mb-1" style={{'font-size': '1rem'}}>
                                        Certificate is awarded on completion of
                                        every level.
                                    </li>
                                    <li className="font-weight-bold mb-1" style={{'font-size': '1rem'}}>
                                        For Children in school
                                    </li>
                                    <li className="font-weight-bold mb-1" style={{'font-size': '1rem'}}>
                                        For People migrating to Canada
                                    </li>
                                    <li className="font-weight-bold mb-1" style={{'font-size': '1rem'}}>
                                        Looking for career in French
                                    </li>
                                    <li className="font-weight-bold mb-1" style={{'font-size': '1rem'}}>
                                        For Hobby learners
                                    </li>


                                </ul>
                            </div>
                            <div className="cell-3">
                                <div className="card cd-depth border-0">
                                    <div className="card-body p-4 pb-0">
                                        <Form
                                            ref={formRef}
                                            name="French_Learning"
                                            className="border-0 cd-form cd-form-theme coder-form"
                                            initialValues={{remember: true}}
                                            onFinishFailed={onFinishFailed}
                                        >
                                            <label className="font-weight-bold">Name</label>
                                            <Form.Item
                                                name="first_name"
                                                rules={[{required: true, message: 'Please input your Full Name'}]}
                                            >
                                                <input type="text" className="text-uppercase"/>
                                            </Form.Item>
                                            <div className={"row"}>
                                                <div className={"col"}>
                                                    <label className="font-weight-bold">Email</label>
                                                    <Form.Item
                                                        name="email1"
                                                        rules={[{
                                                            type: 'email', message: 'The is not a valid E-mail!',
                                                        }, {
                                                            required: true, message: 'Please enter vaild E-mail!',
                                                        },]}
                                                    >
                                                        <input type="email"/>
                                                    </Form.Item>
                                                </div>
                                                <div className={"col"}>
                                                    <label className="font-weight-bold">Contact Number</label>
                                                    <Form.Item
                                                        name="phone_mobile"
                                                        rules={[{
                                                            validator: (_, value) => parseInt(value).toString().length === 10 ? Promise.resolve() : Promise.reject(new Error('Please input your phone number!')),
                                                        },]}
                                                    >
                                                        <Input addonBefore={prefixSelector}/>
                                                    </Form.Item>
                                                </div>
                                            </div>
                                            <label className="font-weight-bold">Your interest</label>
                                            <Form.Item
                                                name="description"
                                                rules={[{required: true, message: 'Please select an option'}]}>
                                                <Radio.Group value={stage} onChange={(e) => setStage(e.target.value)}>
                                                    <Space direction="vertical">
                                                        <Radio value="school_student">School Student</Radio>
                                                        <Radio value="hobby_learner">Hobby Learner</Radio>
                                                    </Space>
                                                    <Space direction="vertical">
                                                        <Radio value="migrating">Migrating</Radio>
                                                        <Radio value="other">Other</Radio>
                                                    </Space>
                                                </Radio.Group>
                                            </Form.Item>
                                            <div className={"d-flex justify-content-between align-items-center"}>
                                                {
                                                    stage === "school_student" ?
                                                        <div>
                                                            <label className="font-weight-bold">Student’s Grade</label>
                                                            <Form.Item
                                                                name="current_class_c"
                                                            >
                                                                <Select style={{width: 120}} onChange={(value) => setCls(value)} value={cls}>
                                                                    <Option value="grade_5">5th</Option>
                                                                    <Option value="grade_6">6th</Option>
                                                                    <Option value="grade_7">7th</Option>
                                                                    <Option value="grade_8">8th</Option>
                                                                    <Option value="grade_9">9th</Option>
                                                                    <Option value="grade_10">10th</Option>
                                                                    <Option value="grade_11_pcm">11th</Option>
                                                                    <Option value="grade_12_pcm">12th</Option>
                                                                </Select>
                                                            </Form.Item>
                                                        </div>
                                                        :
                                                        <div/>
                                                }

                                                <Form.Item className="my-4">
                                                    <div className={"french-form-btn text-right"}>
                                                        <Button className="btn text-white font-weight-bold h-100"
                                                                style={{'backgroundColor': '#EC705C'}}
                                                                type="submit" htmltype="submit"
                                                                onClick={() => onFinish()}
                                                                loading={loading}
                                                        >
                                                            Book Free Counseling
                                                        </Button>
                                                    </div>
                                                </Form.Item>
                                            </div>
                                        </Form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='bg-1 py-5'>
                <div className="cd-container">
                    <div className="card cd-depth border-0 cd-round-edge-md p-md-4 cd-data-up-2">
                        <div className="card-body">
                            <div className="card-group text-center" id="french_features">
                                <div className="card border-0">
                                    <div className="card-body">
                                        <p><img loading="lazy" src={Foundation} alt="Foundation"/></p>
                                        <p className="h5 font-weight-bold">Foundation</p>
                                        <p className="m-0">Start Speaking French promptly
                                            using essential words and phrases.</p>
                                    </div>
                                </div>
                                <div className="card border-0">
                                    <div className="card-body">
                                        <p><img loading="lazy" src={Learning} alt="Learning"/></p>
                                        <p className="h5 font-weight-bold">Simple Learning</p>
                                        <p className="m-0">Develop confidence in every
                                            lesson as you progress from new
                                            vocabulary to effective conversations.</p>
                                    </div>
                                </div>
                                <div className="card border-0">
                                    <div className="card-body">
                                        <p><img loading="lazy" src={Comprehensive} alt="Comprehensive"/></p>
                                        <p className="h5 font-weight-bold">Comprehensive</p>
                                        <p className="m-0">Includes comprehension, Grammar,
                                            Vocabulary, dialogues, exercises and more.</p>
                                    </div>
                                </div>
                                <div className="card border-0">
                                    <div className="card-body">
                                        <p><img loading="lazy" src={Recall} alt="Recall" height="64" width="64"/></p>
                                        <p className="h5 font-weight-bold">Easy Recall</p>
                                        <p className="m-0">Unique retention exercises,
                                            move your new language from
                                            short-term memory to long-term memory.</p>
                                    </div>
                                </div>
                                <div className="card border-0">
                                    <div className="card-body">
                                        <p><img loading="lazy" src={Affordable} alt="Affordable"/></p>
                                        <p className="h5 font-weight-bold">Affordable</p>
                                        <p className="m-0">Afordable for the school and student with minimal fees.</p>
                                    </div>
                                </div>
                            </div>

                            <p className="display-4 font-weight-bold mb-4 text-center">Why Should you <span
                                className="cd-red-text">Learn French?</span></p>
                            <div className="text-center" id="french-facts">
                                <div className="card cd-depth cd-round-edge-sm border-0">
                                    <div className="card-body">French is the offcial language in 55 countries and is the
                                        second most learnt language
                                    </div>
                                </div>
                                <div className="card cd-depth cd-round-edge-sm border-0">
                                    <div className="card-body">Ability to speak French will increase one’s job
                                        opportunities and salary potential!
                                    </div>
                                </div>
                                <div className="card cd-depth cd-round-edge-sm border-0">
                                    <div className="card-body">Advantage of studying in France and French speaking
                                        countries like Canada.
                                    </div>
                                </div>
                                <div className="card cd-depth cd-round-edge-sm border-0">
                                    <div className="card-body">Over 50% of English words have their origins in French!
                                    </div>
                                </div>
                                <div className="card cd-depth cd-round-edge-sm border-0">
                                    <div className="card-body">Makes immigration in another countries easier as it helps
                                        you to attain more points under PBS.
                                    </div>
                                </div>
                                <div className="card cd-depth cd-round-edge-sm border-0">
                                    <div className="card-body">Improves business opportunities as France is Europe’s
                                        foremost investor abroad!
                                    </div>
                                </div>
                                <div className="card cd-depth cd-round-edge-sm border-0">
                                    <div className="card-body">Learning French will develop one’s critical and creative
                                        thinking skills!
                                    </div>
                                </div>
                                <div className="card cd-depth cd-round-edge-sm border-0">
                                    <div className="card-body">French is one of the most frequently used languages on
                                        the Internet!
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="cd-container">
                    <div
                        className="card cd-depth cd-round-edge border-0 mb-5 p-md-4 pb-md-0 border-left border-primary  cd-margin-top-10">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-12">
                                    <h1 className="font-weight-bold text-cd-center">French as a <span
                                        className="cd-blue-text">Career</span></h1>
                                    <p className="font-weight-normal text-cd-justify">Organization internationale de la
                                        Francophonie (OIF) is a group of 88 countries where the French language is
                                        spoken frequently. If any student wants to apply for higher education or a job
                                        in any of these countries, knowledge of French can enhance and brighten the
                                        chances to get selected. Pursuing a career in these countries requires knowledge
                                        of French as a primary language. French can be considered as a mother tongue in
                                        the romance language umbrella. It is the fourth most spoken language across
                                        Europe. France has an enriched cultural history, and French is a gate to enter
                                        the world full of history and knowledge. As per the total number of speakers,
                                        French is the fifth most spoken language in the world.</p>
                                    <h5 className="font-weight-bold">Career Dose’s French Tutorials are Exploratory in
                                        Teaching Methods</h5>
                                    <p className="font-weight-normal text-cd-justify">Our teachers are self-motivated,
                                        and they are never afraid to explore more in teaching methods. We know the
                                        importance of french language, and we don’t want our students to feel low in any
                                        situation. Our teachers always come up with ideas to make more connection so
                                        that students can feel indulged, and they remain motivated throughout the
                                        learning process.</p>
                                    <h5 className="font-weight-bold">Why Us?</h5>
                                    <p className="font-weight-normal text-cd-justify">Our purpose in Career Dose is to
                                        help the young generation to have all-around development of their energetic
                                        brains. Our ideology defines our intentions. We want to inspire young minds. We
                                        want to show them various career prospects. Career Dose is a lean and a
                                        fast-growing organization aimed to nourish the future fuel of this country.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card cd-depth cd-round-edge border-0 my-5 p-md-4 border-left border-success">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-12">
                                    <TestimonialsSection type={'french'}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
